import React, { useContext } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import Flex from '@wix/da-ds/pkg/Flex';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContent from '../FolderContent';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
}

const DesktopGallectionSimpleView: React.FC<Props> = ({ currentFolder }) => {
  const withAds = useFlag('ads_nitro');
  const { isLoggedIn } = useContext(SessionContext);
  const renderSliderArea = () => {
    if (withAds && !isLoggedIn) {
      return (
        <Flex direction="row" className={s['folders-and-ad']}>
          <Flex direction="column" className={s['folders']}>
            <FoldersHeader className={s['folders-header']} />
            <FolderSlider className={s['slider']} />
          </Flex>
          <div className={s['ad-slot']} />
        </Flex>
      );
    } else {
      return (
        <>
          <FoldersHeader />
          <FolderSlider />
        </>
      );
    }
  };
  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="DesktopGallectionSimpleView">
        {renderSliderArea()}
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent
              key={currentFolder?.folderId}
              folderId={currentFolder?.folderId || 0}
            />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionSimpleView.displayName = 'DesktopGallectionSimpleView';

export default DesktopGallectionSimpleView;
